<template>
  <window-portal :open="dataProps.show" @close="onClose">
    <preview-document
      :config="previewConfig"
      :send-email="!hideQr"
      :download-json="!hideQr"
      @clickSendEmail="sendEmail"
      @clickDownloadJson="downLoadJSON"
      :mail-label="mailLabel"
    >
      <template #pages="{ config }">
        <preview-page
          v-for="(pageData, pIndex) in pagesData"
          :key="`page-${pIndex}`"
          :config="config"
          :watermarkSrc="imageOpacity"
        >
          <!-- page-header -->
          <template #header>
            <!-- logo y fecha-->
            <div
              style="
                background-color: #113a40;
                height: 20px;
                margin-bottom: 10px;
              "
            ></div>
            <div style="display: flex; justify-content: space-between">
              <div style="width: 30%">
                <img
                  style="height: auto; max-height: 170px !important; width: 90%"
                  :src="dataProps.data.branch.BranchLogoPath"
                />
                <template>
                  <table
                    style="
                      margin-right: auto;
                      margin-left: auto;
                      color: white;
                      border-spacing: 0;
                      width: 90%;
                    "
                  >
                    <tr>
                      <th
                        style="
                          padding: 5px;
                          border: 1px solid #113a40;
                          background-color: #113a40;
                          border-top-left-radius: 10px;
                          color: white;
                        "
                      >
                        Día
                      </th>
                      <th
                        style="
                          padding: 5px;
                          border: 1px solid #113a40;
                          background-color: #113a40;
                          color: white;
                        "
                      >
                        Mes
                      </th>
                      <th
                        style="
                          padding: 5px;
                          border: 1px solid #113a40;
                          background-color: #113a40;
                          border-top-right-radius: 10px;
                          color: white;
                          text-align: center
                        "
                      >
                        Año
                      </th>
                    </tr>
                    <tr>
                      <td
                        style="
                          border: 1px solid #113a40;
                          padding: 10px;
                          border-bottom-left-radius: 10px;
                          color: #113a40;
                          font-size: 12pt;
                          font-weight: 500;
                          text-align: center
                        "
                      >
                        {{ dateInvoice.dia }}
                      </td>
                      <td
                        style="
                          border: 1px solid #113a40;
                          padding: 10px;
                          color: #113a40;
                          font-size: 12pt;
                          font-weight: 500;
                          text-align: center
                        "
                      >
                        {{ dateInvoice.mes }}
                      </td>
                      <td
                        style="
                          border: 1px solid #113a40;
                          padding: 10px;
                          border-bottom-right-radius: 10px;
                          color: #113a40;
                          font-size: 12pt;
                          font-weight: 500;
                          text-align: center
                        "
                      >
                        {{ dateInvoice.anio }}
                      </td>
                    </tr>
                  </table>
                </template>
              </div>
              <!-- detalle negocio y qr-->
              <div>
                <div style="color: #113a40; font-size: 14pt; text-align: right">
                  {{
                    !hideQr
                      ? "DOCUMENTO TRIBUTARIO ELECTRÓNICO"
                      : "DOCUMENTO SIN VALIDEZ LEGAL"
                  }}
                </div>
                <template>
                  <div style="color: #f4c171; text-align: right">
                    {{
                      dataProps.data.header.InvoiceType == "FCF"
                        ? "FACTURA CONSUMIDOR FINAL"
                        : ""
                    }}
                  </div>
                  <div style="color: #f4c171; text-align: right">
                    {{
                      dataProps.data.header.InvoiceType == "CCF"
                        ? "COMPROBANTE DE CRÉDITO FISCAL"
                        : ""
                    }}
                  </div>
                  <div style="color: #f4c171; text-align: right">
                    {{
                      dataProps.data.header.InvoiceType == "FNS"
                        ? "FACTURA SUJETO EXCLUIDO"
                        : ""
                    }}
                  </div>
                  <div style="color: #f4c171; text-align: right">
                    {{
                      dataProps.data.header.InvoiceType == "FEX"
                        ? "FACTURA DE EXPORTACIÓN"
                        : ""
                    }}
                  </div>
                  <div style="color: #f4c171; text-align: right">
                    {{
                      dataProps.data.header.InvoiceType == "DNC"
                        ? "NOTA DE CRÉDITO"
                        : ""
                    }}
                  </div>
                  <div style="color: #f4c171; text-align: right">
                    {{
                      dataProps.data.header.InvoiceType == "DND"
                        ? "NOTA DE DÉBITO"
                        : ""
                    }}
                  </div>
                  <div style="color: #f4c171; text-align: right">
                    {{
                      dataProps.data.header.InvoiceType == "CDD"
                        ? "COMPROBANTE DE DONACIÓN"
                        : ""
                    }}
                  </div>
                  <div style="color: #f4c171; text-align: right">
                    {{
                      dataProps.data.header.InvoiceType == "DNR"
                        ? "NOTA DE REMISIÓN"
                        : ""
                    }}
                  </div>
                </template>
                <div
                  style="
                    display: flex;
                    justify-content: space-between;
                    font-size: 9pt;
                    margin-top: 10px;
                  "
                >
                  <div>
                    <div>
                      <b>Código de generación: </b
                      >{{ dataProps.data.header.CodigoGeneracion }}
                    </div>
                    <div>
                      <b>Sello de recepción: </b
                      >{{ dataProps.data.header.SelloRecepcion }}
                    </div>
                    <div>
                      <b>Número de control: </b
                      >{{ dataProps.data.header.NumeroControl }}
                    </div>
                    <div>
                      <b>Correlativo de factura: </b
                      >{{ dataProps.data.header.ID_Invoice }}
                    </div>
                    <div>
                      <b>NIT: </b
                      >{{ dataProps.data.branch.BusinessBillingNIT || "---" }}
                    </div>
                    <div>
                      <b>NRC: </b
                      >{{ dataProps.data.branch.BusinessBillingNRC || "---" }}
                    </div>
                  </div>
                  <div style="margin-left: 20px">
                    <img ref="qrcode" :src="urlQr" />
                  </div>
                </div>
                <div
                  style="
                    display: flex;
                    justify-content: space-between;
                    font-size: 9pt;
                    margin-top: 10px;
                  "
                >
                  <div>
                    <b>Modelo de facturación: </b
                    >{{
                      dataProps.data.dteJson.IdentificacionTipoModelo == 1
                        ? "Previo"
                        : "Diferido"
                    }}
                  </div>
                  <div><b>Proyecto:</b></div>
                  <div></div>
                </div>
                <div style="font-size: 9pt">
                  <b>Tipo de transmisión: </b
                  >{{
                    dataProps.data.dteJson.IdentificacionTipoModelo == 1
                      ? "Normal"
                      : "Por contingencía"
                  }}
                </div>
              </div>
            </div>

            <!-- Datos emisor y receptor inicio -->
            <div style="display: flex; font-size: 8pt">
              <!-- datos emisor -->
              <div
                style="
                  -webkit-border-radius: 10px;
                  -moz-border-radius: 10px;
                  border-radius: 10px;
                  border: 1px solid #113a40;
                  flex-grow: 1;
                  padding: 20px;
                  flex: 1 1 0px;
                  margin-right: 5px;
                  margin-top: 30px;
                "
              >
                <div
                  style="
                    color: white;
                    font-size: 10pt;
                    margin-bottom: 10px;
                    margin-top: -30px;
                  "
                >
                  <span
                    style="
                      background-color: #f4c171;
                      padding: 2px 10px;
                      border-radius: 10px;
                    "
                    >DATOS EMISOR:</span
                  >
                </div>
                <div>
                  <b>Razón social:</b>
                  {{ dataProps.data.branch.BusinessBillingName || "---" }}
                </div>
                <div>
                  <b>Actividad Económica:</b>
                  {{ dataProps.data.header.EmisorDescActividad || "---" }}
                </div>
                <div>
                  <b>Dirección:</b>
                  {{ dataProps.data.branch.BranchLegalAddress || "---" }}
                </div>
                <div>
                  <b>Teléfono:</b>
                  {{
                    dataProps.data.branch.BranchPhone ||
                    dataProps.data.branch.BranchMobile ||
                    "---"
                  }}
                </div>
                <div>
                  <b>Correo:</b>{{ dataProps.data.branch.BranchEmail || "---" }}
                </div>
              </div>
              <!-- datos receptor -->
              <div
                style="
                  -webkit-border-radius: 10px;
                  -moz-border-radius: 10px;
                  border-radius: 10px;
                  border: 1px solid #113a40;
                  flex-grow: 1;
                  padding: 20px;
                  flex: 1 1 0px;
                  margin-top: 30px;
                "
              >
                <div
                  style="
                    color: white;
                    font-size: 10pt;
                    margin-bottom: 10px;
                    margin-top: -30px;
                  "
                >
                  <span
                    style="
                      background-color: #f4c171;
                      padding: 2px 10px;
                      border-radius: 10px;
                    "
                    >DATOS RECEPTOR:</span
                  >
                </div>
                <div>
                  <b>Razón social:</b>
                  {{ dataProps.data.header.InvoiceName || "---" }}
                </div>
                <div>
                  <b>NIT:</b> {{ dataProps.data.header.InvoiceNIT || "---" }}
                </div>
                <div>
                  <b>NRC:</b> {{ dataProps.data.header.InvoiceNRC || "---" }}
                </div>
                <div>
                  <b>Actividad Económica:</b>
                  {{ dataProps.data.dteJson.ReceptorDescActividad || "---" }}
                </div>
                <div>
                  <b>Dirección:</b>
                  {{ dataProps.data.header.InvoiceAddress || "---" }}
                </div>
                <div>
                  <b>Teléfono:</b>
                  {{
                    dataProps.data.header.ClienteTelefonoMovilDeContacto ||
                    dataProps.data.header.ClienteTelefonoFijoDeContacto ||
                    "---"
                  }}
                </div>
                <div>
                  <b>Correo:</b>
                  {{ dataProps.data.header.ReceptorCorreo || "---" }}
                </div>
              </div>
            </div>
            <!-- Datos emisor y receptor fin -->

            <!-- tabla DNC y DND -->
            <template
              v-if="
                dataProps.data.header.InvoiceType == 'DNC' ||
                dataProps.data.header.InvoiceType == 'DND'
              "
            >
              <table
                style="
                  border: 1px solid #113a40;
                  border-spacing: 0;
                  margin-top: 10px;
                  font-size: 8pt;
                  width: 100%;
                  border-top-left-radius: 10px;
                  border-top-right-radius: 10px;
                  border-bottom-left-radius: 10px;
                  border-bottom-right-radius: 10px;
                  overflow: hidden;
                "
              >
                <tr style="background-color: #113a40; color: white">
                  <th colspan="3">DOCUMENTOS RELACIONADOS</th>
                </tr>
                <tr
                  style="
                    background-color: #113a40;
                    color: white;
                    text-align: center;
                  "
                >
                  <th style="padding: 5px">Tipo de Documento</th>
                  <th>Nº de Documento</th>
                  <th>Fecha de Documento</th>
                </tr>
                <tr
                  v-for="(item, index) in dataProps.data.docRelated"
                  :key="index"
                  style="text-align: center"
                >
                  <td style="padding: 5px">
                    {{
                      item.TipoDocumentoRelacionado == "03"
                        ? "Comprobante de Crédito Fiscal"
                        : ""
                    }}
                  </td>
                  <td>{{ item.NumeroDocumentoRelacionado }}</td>
                  <td>{{ item.FechaEmisionRelacionado }}</td>
                </tr>
              </table>
            </template>
            <!-- tabla documentos relacionados facturas CDD -->
            <template v-if="dataProps.data.header.InvoiceType == 'CDD'">
              <table
                style="
                  border: 1px solid #113a40;
                  border-spacing: 0;
                  margin-top: 10px;
                  font-size: 8pt;
                  width: 100%;
                  border-top-left-radius: 10px;
                  border-top-right-radius: 10px;
                  border-bottom-left-radius: 10px;
                  border-bottom-right-radius: 10px;
                  overflow: hidden;
                "
              >
                <tr style="background-color: #113a40; color: white">
                  <th colspan="3">DOCUMENTOS RELACIONADOS</th>
                </tr>
                <tr
                  style="
                    background-color: #113a40;
                    color: white;
                    text-align: center;
                  "
                >
                  <th style="padding: 5px">Documento Asociado</th>
                  <th>Nº Documento Asociado</th>
                  <th>Descripción</th>
                </tr>
                <tr style="text-align: center">
                  <td style="padding: 5px">
                    {{ dataProps.data.dteJson.OtrosDocumentosCodDocAsociado }}
                  </td>
                  <td>
                    {{ dataProps.data.dteJson.OtrosDocumentosDescDocumento }}
                  </td>
                  <td>
                    {{ dataProps.data.dteJson.OtrosDocumentosDetalleDocumento }}
                  </td>
                </tr>
              </table>
            </template>

            <!-- Encabezados tabla -->
            <table
              style="
                border: 1px solid #113a40;
                color: white;
                font-size: 8pt;
                background-color: #113a40;
                width: 100%;
                margin-top: 10px;
                border-top-left-radius: 10px;
                border-top-right-radius: 10px;
                overflow: hidden;
              "
            >
              <template v-if="dataProps.data.header.InvoiceType === 'CDD'">
                <colgroup>
                  <col style="width: 100px" />
                  <col style="width: 460px" />
                  <col style="width: 150px" />
                  <col style="width: 150px" />
                  <col style="width: 150px" />
                  <col style="width: 150px" />
                </colgroup>
              </template>

              <template v-else-if="dataProps.data.header.InvoiceType === 'FEX'">
                <colgroup>
                  <col style="width: 100px" />
                  <col style="width: 460px" />
                  <col style="width: 150px" />
                  <col style="width: 150px" />
                  <col style="width: 150px" />
                  <col style="width: 150px" />
                  <col style="width: 150px" />
                  <col style="width: 150px" />
                </colgroup>
              </template>

              <template v-else>
                <colgroup>
                  <col style="width: 40px" />
                  <col style="width: 325px" />
                  <col style="width: 80px" />
                  <col style="width: 80px" />
                  <col style="width: 75px" />
                  <col style="width: 75px" />
                  <col style="width: 80px" />
                  <col style="width: 80px" />
                  <col style="width: 80px" />
                </colgroup>
              </template>

              <tr>
                <th>No item</th>
                <th>Descripción</th>
                <th>Cantidad</th>
                <th>Unidad</th>
                <th>Precio Unitario</th>
                <th v-if="dataProps.data.header.InvoiceType != 'CDD'">
                  Descuento
                </th>
                <th
                  v-if="
                    dataProps.data.header.InvoiceType != 'FEX' &&
                    dataProps.data.header.InvoiceType != 'CDD'
                  "
                >
                  Ventas No Sujetas
                </th>
                <th
                  v-if="
                    dataProps.data.header.InvoiceType != 'FEX' &&
                    dataProps.data.header.InvoiceType != 'CDD'
                  "
                >
                  Ventas Exentas
                </th>
                <th
                  v-if="
                    dataProps.data.header.InvoiceType != 'FEX' &&
                    dataProps.data.header.InvoiceType != 'CDD'
                  "
                >
                  Ventas Gravadas
                </th>
                <th v-if="dataProps.data.header.InvoiceType == 'FEX'">
                  Otros montos no afectos
                </th>
                <th v-if="dataProps.data.header.InvoiceType == 'FEX'">
                  Ventas afectas
                </th>
                <th v-if="dataProps.data.header.InvoiceType == 'CDD'">
                  Valor Donado
                </th>
              </tr>
            </table>
          </template>
          <!-- page body -->
          <div>
            <!-- tabla factura -->
            <table
              style="
                border: 1px solid #113a40;
                font-size: 8pt;
                width: 100%;
                border-spacing: 0;
                border-bottom-left-radius: 10px;
                border-bottom-right-radius: 10px;
              "
            >
              <template v-if="dataProps.data.header.InvoiceType === 'CDD'">
                <colgroup>
                  <col style="width: 100px" />
                  <col style="width: 460px" />
                  <col style="width: 150px" />
                  <col style="width: 150px" />
                  <col style="width: 150px" />
                  <col style="width: 150px" />
                </colgroup>
              </template>

              <template v-else-if="dataProps.data.header.InvoiceType === 'FEX'">
                <colgroup>
                  <col style="width: 100px" />
                  <col style="width: 460px" />
                  <col style="width: 150px" />
                  <col style="width: 150px" />
                  <col style="width: 150px" />
                  <col style="width: 150px" />
                  <col style="width: 150px" />
                  <col style="width: 150px" />
                </colgroup>
              </template>

              <template v-else>
                <colgroup>
                  <col style="width: 40px" />
                  <col style="width: 325px" />
                  <col style="width: 80px" />
                  <col style="width: 80px" />
                  <col style="width: 75px" />
                  <col style="width: 75px" />
                  <col style="width: 80px" />
                  <col style="width: 80px" />
                  <col style="width: 80px" />
                </colgroup>
              </template>
              <tr
                v-for="(row, rIndex) in pageData"
                :key="`row-${pIndex}-${rIndex}`"
              >
                <td
                  style="padding: 5px; text-align: center"
                  v-html="row.index"
                ></td>
                <td style="padding: 5px">{{ row.ItemDescription }}</td>
                <td style="padding: 5px; text-align: center">
                  {{ row.ItemQuantity }}
                </td>
                <td style="padding: 5px; text-align: center">
                  {{ row.ItemMeasureUnit }}
                </td>
                <td style="padding: 5px; text-align: right; padding: 5px">
                  {{
                    formatWithCommas(parseFloat(row.ItemUnitPrice).toFixed(2))
                  }}
                </td>
                <td
                  v-if="dataProps.data.header.InvoiceType != 'CDD'"
                  style="padding: 5px; text-align: right; padding: 5px"
                >
                  {{
                    formatWithCommas(parseFloat(row.ItemDiscount).toFixed(2))
                  }}
                </td>
                <td
                  v-if="
                    dataProps.data.header.InvoiceType != 'FEX' &&
                    dataProps.data.header.InvoiceType != 'CDD'
                  "
                  style="padding: 5px; text-align: right; padding: 5px"
                >
                  {{ formatWithCommas(parseFloat(row.ItemNoSuj).toFixed(2)) }}
                </td>
                <td
                  v-if="
                    dataProps.data.header.InvoiceType != 'FEX' &&
                    dataProps.data.header.InvoiceType != 'CDD'
                  "
                  style="padding: 5px; text-align: right; padding: 5px"
                >
                  {{ formatWithCommas(parseFloat(row.ItemExenta).toFixed(2)) }}
                </td>
                <td
                  v-if="
                    dataProps.data.header.InvoiceType != 'FEX' &&
                    dataProps.data.header.InvoiceType != 'CDD'
                  "
                  style="padding: 5px; text-align: right; padding: 5px"
                >
                  {{ formatWithCommas(parseFloat(row.ItemGravada).toFixed(2)) }}
                </td>
                <td
                  v-if="dataProps.data.header.InvoiceType == 'FEX'"
                  style="padding: 5px; text-align: right; padding: 5px"
                >
                  {{
                    formatWithCommas(parseFloat(row.montoNoAfecto).toFixed(2))
                  }}
                </td>
                <td
                  v-if="dataProps.data.header.InvoiceType == 'FEX'"
                  style="padding: 5px; text-align: right; padding: 5px"
                >
                  {{ formatWithCommas(parseFloat(row.ItemGravada).toFixed(2)) }}
                </td>
                <td
                  v-if="dataProps.data.header.InvoiceType == 'CDD'"
                  style="padding: 5px; text-align: right; padding: 5px"
                >
                  {{ formatWithCommas(parseFloat(row.ItemGravada).toFixed(2)) }}
                </td>
              </tr>
            </table>

            <!-- sumas y totales -->
            <div
              v-if="pIndex + 1 === totalPages"
              style="
                margin-top: 10px;
                font-size: 7pt;
                display: flex;
                justify-content: space-between;
              "
            >
              <!-- valor en letras y responsables -->
              <div style="flex-grow: 1; flex: 1 1 0px; margin-right: 10px">
                <div
                  style="
                    border: 1px solid #113a40;
                    border-radius: 10px;
                    padding: 20px;
                  "
                >
                  Valor en letras:
                  {{ dataProps.data.header.InvoiceTotalLetras }}
                </div>
                <!-- responsables y observaciones -->
                <div
                  style="
                    border: 1px solid #113a40;
                    border-radius: 10px;
                    margin-top: 10px;
                  "
                >
                  <div style="border-bottom: 1px solid #113a40; padding: 10px">
                    Responsable por parte de EMISOR:
                    {{ dataProps.data.header.InvoiceExtNombEntrega || dataProps.data.header.FullName || "--" }}
                  </div>
                  <div style="padding: 10px">
                    Responsable por parte de RECEPTOR:
                    {{
                      dataProps.data.header.InvoiceExtNombRecibe ||
                      dataProps.data.header?.customerInfo
                        ?.BusinessContactName ||
                      dataProps.data.header.ReceptorNombre ||
                      "--"
                    }}
                  </div>
                </div>
                <div style="margin-top: 5px; padding: 10px">
                  Observaciones: {{ 
                    (dataProps.data.header.RulesToShowComments && dataProps.data.header.RulesToShowComments == 2) ? '' : commentsOuterHtml
                  }}
                </div>
              </div>
              <!-- sumas detalles -->
              <div style="flex-grow: 1; flex: 1 1 0px">
                <!-- sumas finales -->
                <div
                  style="
                    border: 1px solid #113a40;
                    border-radius: 10px;
                    padding: 10px;
                  "
                >
                  <table style="font-size: 7pt">
                    <template
                      v-if="dataProps.data.header.InvoiceType === 'CDD'"
                    >
                      <colgroup>
                        <col style="width: 450px" />
                        <col style="width: 150px" />
                      </colgroup>
                    </template>

                    <template
                      v-else-if="dataProps.data.header.InvoiceType === 'FEX'"
                    >
                      <colgroup>
                        <col style="width: 300px" />
                        <col style="width: 150px" />
                        <col style="width: 150px" />
                        <col style="width: 150px" />
                      </colgroup>
                    </template>

                    <template v-else>
                      <colgroup>
                        <col style="width: 120px" />
                        <col style="width: 80px" />
                        <col style="width: 80px" />
                        <col style="width: 80px" />
                        <col style="width: 80px" />
                      </colgroup>
                    </template>

                    <tr>
                      <td style="text-align: center">Sumas:</td>
                      <td
                        v-if="dataProps.data.header.InvoiceType !== 'CDD'"
                        style="text-align: right; padding: 5px"
                      >
                        {{
                          formatWithCommas(
                            parseFloat(totals.discount).toFixed(2)
                          )
                        }}
                      </td>
                      <td
                        v-if="
                          dataProps.data.header.InvoiceType !== 'CDD' &&
                          dataProps.data.header.InvoiceType !== 'FEX'
                        "
                        style="text-align: right; padding: 5px"
                      >
                        {{
                          formatWithCommas(
                            parseFloat(totals.noSujetas).toFixed(2)
                          )
                        }}
                      </td>
                      <td
                        v-if="
                          dataProps.data.header.InvoiceType !== 'CDD' &&
                          dataProps.data.header.InvoiceType !== 'FEX'
                        "
                        style="text-align: right; padding: 5px"
                      >
                        {{
                          formatWithCommas(
                            parseFloat(totals.exentas).toFixed(2)
                          )
                        }}
                      </td>
                      <td
                        v-if="dataProps.data.header.InvoiceType === 'FEX'"
                        style="text-align: right; padding: 5px"
                      >
                        {{
                          formatWithCommas(
                            parseFloat(totals.otrosMontos).toFixed(2)
                          )
                        }}
                      </td>
                      <td style="text-align: right; padding: 5px">
                        {{
                          formatWithCommas(
                            parseFloat(totals.gravadas).toFixed(2)
                          )
                        }}
                      </td>
                    </tr>
                  </table>
                </div>

                <!-- <div>
                  <pre>{{dataProps.data.header}}</pre>
                </div> -->

                <!-- detalles totales -->
                <div
                  style="
                    border: 1px solid #113a40;
                    border-radius: 10px;
                    margin-top: 10px;
                  "
                >
                  <table style="font-size: 7pt; border-collapse: collapse">
                    <colgroup>
                      <col style="width: 150px" />
                      <col style="width: 250px" />
                    </colgroup>

                    <!-- Detalles para facturas FEX -->
                    <template v-if="dataProps.data.header.InvoiceType == 'FEX'">
                      <tr>
                        <td
                          style="
                            border-right: 1px solid #113a40;
                            border-bottom: 1px solid #113a40;
                            padding: 5px;
                            text-align: right;
                          "
                        >
                          Total de Operaciones Afectas:
                        </td>
                        <td
                          style="
                            text-align: right;
                            padding: 5px;
                            border-bottom: 1px solid #113a40;
                          "
                        >
                          $
                          {{
                            formatWithCommas(
                              parseFloat(
                                dataProps.data.header.InvoiceSubTotalVentas
                              ).toFixed(2)
                            )
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style="
                            border-right: 1px solid #113a40;
                            border-bottom: 1px solid #113a40;
                            padding: 5px;
                            text-align: right;
                          "
                        >
                          Monto global de Desc., Rebajas de operaciones afectas:
                        </td>
                        <td
                          style="
                            text-align: right;
                            padding: 5px;
                            border-bottom: 1px solid #113a40;
                          "
                        >
                          $
                          {{
                            formatWithCommas(
                              parseFloat(
                                dataProps.data.header.InvoiceTotalDescu
                              ).toFixed(2)
                            )
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style="
                            border-right: 1px solid #113a40;
                            border-bottom: 1px solid #113a40;
                            padding: 5px;
                            text-align: right;
                          "
                        >
                          Flete:
                        </td>
                        <td
                          style="
                            text-align: right;
                            padding: 5px;
                            border-bottom: 1px solid #113a40;
                          "
                        >
                          $
                          {{
                            formatWithCommas(
                              parseFloat(dataProps.data.header.Flete).toFixed(2)
                            )
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style="
                            border-right: 1px solid #113a40;
                            border-bottom: 1px solid #113a40;
                            padding: 5px;
                            text-align: right;
                          "
                        >
                          Seguro:
                        </td>
                        <td
                          style="
                            text-align: right;
                            padding: 5px;
                            border-bottom: 1px solid #113a40;
                          "
                        >
                          $
                          {{
                            formatWithCommas(
                              parseFloat(dataProps.data.header.Seguro).toFixed(
                                2
                              )
                            )
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style="
                            border-right: 1px solid #113a40;
                            border-bottom: 1px solid #113a40;
                            padding: 5px;
                            text-align: right;
                          "
                        >
                          Monto total de la operación:
                        </td>
                        <td
                          style="
                            text-align: right;
                            padding: 5px;
                            border-bottom: 1px solid #113a40;
                          "
                        >
                          $
                          {{
                            formatWithCommas(
                              parseFloat(
                                dataProps.data.header.InvoiceTotalPagar
                              ).toFixed(2)
                            )
                          }}
                        </td>
                      </tr>
                    </template>
                    <!-- Detalle facturas tipo DNC y DND -->
                    <template
                      v-else-if="
                        dataProps.data.header.InvoiceType == 'DND' ||
                        dataProps.data.header.InvoiceType == 'DNC'
                      "
                    >
                      <tr>
                        <td
                          style="
                            border-right: 1px solid #113a40;
                            border-bottom: 1px solid #113a40;
                            padding: 5px;
                            text-align: right;
                          "
                        >
                          Sub total de ventas:
                        </td>
                        <td
                          style="
                            text-align: right;
                            padding: 5px;
                            border-bottom: 1px solid #113a40;
                          "
                        >
                          $
                          {{
                            formatWithCommas(
                              parseFloat(
                                dataProps.data.header.InvoiceSubTotalVentas
                              ).toFixed(2)
                            )
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style="
                            border-right: 1px solid #113a40;
                            border-bottom: 1px solid #113a40;
                            padding: 5px;
                            text-align: right;
                          "
                        >
                          Monto global Des., Rebajas y otros a ventas no
                          sujetas:
                        </td>
                        <td
                          style="
                            text-align: right;
                            padding: 5px;
                            border-bottom: 1px solid #113a40;
                          "
                        >
                          $
                          {{
                            formatWithCommas(
                              parseFloat(
                                dataProps.data.header.InvoiceDescuNoSuj
                              ).toFixed(2)
                            )
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style="
                            border-right: 1px solid #113a40;
                            border-bottom: 1px solid #113a40;
                            padding: 5px;
                            text-align: right;
                          "
                        >
                          Monto global Des., Rebajas y otros a ventas exentas:
                        </td>
                        <td
                          style="
                            text-align: right;
                            padding: 5px;
                            border-bottom: 1px solid #113a40;
                          "
                        >
                          $
                          {{
                            formatWithCommas(
                              parseFloat(
                                dataProps.data.header.InvoiceDescuExenta
                              ).toFixed(2)
                            )
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style="
                            border-right: 1px solid #113a40;
                            border-bottom: 1px solid #113a40;
                            padding: 5px;
                            text-align: right;
                          "
                        >
                          Monto global Des., Rebajas y otros a ventas gravadas:
                        </td>
                        <td
                          style="
                            text-align: right;
                            padding: 5px;
                            border-bottom: 1px solid #113a40;
                          "
                        >
                          $
                          {{
                            formatWithCommas(
                              parseFloat(
                                dataProps.data.header.InvoiceDescuGravada
                              ).toFixed(2)
                            )
                          }}
                        </td>
                      </tr>
                      <tr
                        v-if="
                          parseFloat(
                            dataProps.data.header.TurismoPorAlojamiento
                          ) > 0
                        "
                      >
                        <td
                          style="
                            border-right: 1px solid #113a40;
                            border-bottom: 1px solid #113a40;
                            padding: 5px;
                            text-align: right;
                          "
                        >
                          Imp. Turismo:
                        </td>
                        <td
                          style="
                            text-align: right;
                            padding: 5px;
                            border-bottom: 1px solid #113a40;
                          "
                        >
                          $
                          {{
                            formatWithCommas(
                              parseFloat(
                                dataProps.data.header.TurismoPorAlojamiento
                              ).toFixed(2)
                            )
                          }}
                        </td>
                      </tr>
                      <tr v-if="dataProps.data.header.InvoiceType !== 'FNS' && dataProps.data.header.InvoiceType !== 'FCF'">
                        <td
                          style="
                            border-bottom: 1px solid #113a40;
                            border-right: 1px solid #113a40;
                            padding: 5px;
                            text-align: right;
                          "
                        >
                          13% IVA:
                        </td>
                        <td
                          style="
                            text-align: right;
                            padding: 5px;
                            border-bottom: 1px solid #113a40;
                          "
                        >
                          $
                          {{
                            formatWithCommas(
                              parseFloat(
                                dataProps.data.header.InvoiceTotalIva
                              ).toFixed(2)
                            )
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style="
                            border-bottom: 1px solid #113a40;
                            border-right: 1px solid #113a40;
                            padding: 5px;
                            text-align: right;
                          "
                        >
                          (-) IVA retenido:
                        </td>
                        <td
                          style="
                            text-align: right;
                            padding: 5px;
                            border-bottom: 1px solid #113a40;
                          "
                        >
                          $
                          {{
                            formatWithCommas(
                              parseFloat(
                                dataProps.data.header.InvoiceIvaRete1
                              ).toFixed(2)
                            )
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style="
                            border-right: 1px solid #113a40;
                            padding: 5px;
                            text-align: right;
                          "
                        >
                          TOTAL:
                        </td>
                        <td style="text-align: right; padding: 5px">
                          $
                          {{
                            formatWithCommas(
                              parseFloat(
                                dataProps.data.header.InvoiceTotalPagar
                              ).toFixed(2)
                            )
                          }}
                        </td>
                      </tr>
                    </template>
                    <template
                      v-else-if="dataProps.data.header.InvoiceType === 'CDD'"
                    >
                      <tr>
                        <td
                          style="
                            border-right: 1px solid #113a40;
                            padding: 5px;
                            text-align: right;
                          "
                        >
                          Total de la donación:
                        </td>
                        <td style="text-align: right; padding: 5px">
                          $
                          {{
                            formatWithCommas(
                              parseFloat(
                                dataProps.data.header.InvoiceTotalPagar
                              ).toFixed(2)
                            )
                          }}
                        </td>
                      </tr>
                    </template>
                    <!-- Detalle totales para tipos factura CCF, FCF y CDD -->
                    <template v-else>
                      <tr>
                        <td
                          style="
                            border-right: 1px solid #113a40;
                            border-bottom: 1px solid #113a40;
                            padding: 5px;
                            text-align: right;
                          "
                        >
                          Total descuento:
                        </td>
                        <td
                          style="
                            text-align: right;
                            padding: 5px;
                            border-bottom: 1px solid #113a40;
                          "
                        >
                          $
                          {{
                            formatWithCommas(
                              parseFloat(
                                dataProps.data.header.InvoiceTotalDescu
                              ).toFixed(2)
                            )
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style="
                            border-bottom: 1px solid #113a40;
                            border-right: 1px solid #113a40;
                            padding: 5px;
                            text-align: right;
                          "
                        >
                          Sub total con descuento:
                        </td>
                        <td
                          style="
                            text-align: right;
                            padding: 5px;
                            border-bottom: 1px solid #113a40;
                          "
                        >
                          $
                          {{
                            formatWithCommas(
                              parseFloat(
                                dataProps.data.header.InvoiceSubTotalVentas
                              ).toFixed(2)
                            )
                          }}
                        </td>
                      </tr>
                      <tr v-if="dataProps.data.header.InvoiceType !== 'FNS' && dataProps.data.header.InvoiceType !== 'FCF'">
                        <td
                          style="
                            border-bottom: 1px solid #113a40;
                            border-right: 1px solid #113a40;
                            padding: 5px;
                            text-align: right;
                          "
                        >
                          13% IVA:
                        </td>
                        <td
                          style="
                            text-align: right;
                            padding: 5px;
                            border-bottom: 1px solid #113a40;
                          "
                        >
                          $
                          {{
                            formatWithCommas(
                              parseFloat(
                                dataProps.data.header.InvoiceTotalIva
                              ).toFixed(2)
                            )
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style="
                            border-bottom: 1px solid #113a40;
                            border-right: 1px solid #113a40;
                            padding: 5px;
                            text-align: right;
                          "
                        >
                          (-) IVA retenido:
                        </td>
                        <td
                          style="
                            text-align: right;
                            padding: 5px;
                            border-bottom: 1px solid #113a40;
                          "
                        >
                          $
                          {{
                            formatWithCommas(
                              parseFloat(
                                dataProps.data.header.InvoiceIvaRete1
                              ).toFixed(2)
                            )
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style="
                            border-bottom: 1px solid #113a40;
                            border-right: 1px solid #113a40;
                            padding: 5px;
                            text-align: right;
                          "
                        >
                          (-) Renta retenido:
                        </td>
                        <td
                          style="
                            text-align: right;
                            padding: 5px;
                            border-bottom: 1px solid #113a40;
                          "
                        >
                          $
                          {{
                            formatWithCommas(
                              parseFloat(
                                dataProps.data.header.InvoiceReteRenta
                              ).toFixed(2)
                            )
                          }}
                        </td>
                      </tr>
                      <tr
                        v-if="
                          parseFloat(
                            dataProps.data.header.TurismoPorAlojamiento
                          ) > 0
                        "
                      >
                        <td
                          style="
                            border-bottom: 1px solid #113a40;
                            border-right: 1px solid #113a40;
                            padding: 5px;
                            text-align: right;
                          "
                        >
                          Imp. Turismo:
                        </td>
                        <td
                          style="
                            text-align: right;
                            padding: 5px;
                            border-bottom: 1px solid #113a40;
                          "
                        >
                          $
                          {{
                            formatWithCommas(
                              parseFloat(
                                dataProps.data.header.TurismoPorAlojamiento
                              ).toFixed(2)
                            )
                          }}
                        </td>
                      </tr>
                      <tr v-if="parseFloat(dataProps.data.header.Fovial) > 0">
                        <td
                          style="
                            border-bottom: 1px solid #113a40;
                            border-right: 1px solid #113a40;
                            padding: 5px;
                            text-align: right;
                          "
                        >
                          Fovial:
                        </td>
                        <td
                          style="
                            text-align: right;
                            padding: 5px;
                            border-bottom: 1px solid #113a40;
                          "
                        >
                          $
                          {{
                            formatWithCommas(
                              parseFloat(dataProps.data.header.Fovial).toFixed(
                                2
                              )
                            )
                          }}
                        </td>
                      </tr>
                      <tr v-if="parseFloat(dataProps.data.header.Cotrans) > 0">
                        <td
                          style="
                            border-bottom: 1px solid #113a40;
                            border-right: 1px solid #113a40;
                            padding: 5px;
                            text-align: right;
                          "
                        >
                          Cotrans:
                        </td>
                        <td
                          style="
                            text-align: right;
                            padding: 5px;
                            border-bottom: 1px solid #113a40;
                          "
                        >
                          $
                          {{
                            formatWithCommas(
                              parseFloat(dataProps.data.header.Cotrans).toFixed(
                                2
                              )
                            )
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style="
                            border-bottom: 1px solid #113a40;
                            border-right: 1px solid #113a40;
                            padding: 5px;
                            text-align: right;
                          "
                        >
                          Venta no sujeta:
                        </td>
                        <td
                          style="
                            text-align: right;
                            padding: 5px;
                            border-bottom: 1px solid #113a40;
                          "
                        >
                          $
                          {{
                            formatWithCommas(
                              parseFloat(
                                dataProps.data.header.InvoiceTotalNoSuj
                              ).toFixed(2)
                            )
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style="
                            border-bottom: 1px solid #113a40;
                            border-right: 1px solid #113a40;
                            padding: 5px;
                            text-align: right;
                          "
                        >
                          Venta exenta:
                        </td>
                        <td
                          style="
                            text-align: right;
                            padding: 5px;
                            border-bottom: 1px solid #113a40;
                          "
                        >
                          $
                          {{
                            formatWithCommas(
                              parseFloat(
                                dataProps.data.header.InvoiceTotalExenta
                              ).toFixed(2)
                            )
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style="
                            border-right: 1px solid #113a40;
                            padding: 5px;
                            text-align: right;
                          "
                        >
                          TOTAL:
                        </td>
                        <td style="text-align: right; padding: 5px">
                          $
                          {{
                            formatWithCommas(
                              parseFloat(
                                dataProps.data.header.InvoiceTotalPagar
                              ).toFixed(2)
                            )
                          }}
                        </td>
                      </tr>
                    </template>
                  </table>
                </div>
              </div>
            </div>
            <!-- fin sumas y totales -->
          </div>
          <!-- page footer -->
          <template #footer>
            <p style="font-size: 10px">
              Pagina {{ pIndex + 1 }} de {{ totalPages }}
            </p>
            <div
              style="background-color: #113a40; height: 20px; margin-top: 10px"
            ></div>
          </template>
        </preview-page>
      </template>
    </preview-document>
  </window-portal>
</template>

<script>
import WindowPortal from "@/components/ReportsAndPrintings/WindowPortal.vue";
import PreviewDocument from "@/components/PreviewDocument/PreviewDocument.vue";
import PreviewPage from "@/components/PreviewDocument/PreviewPage.vue";
import QRCode from "qrcode";
import { numberWithCommas } from "../../helpers/money";

export default {
  name: "PrintPosCocoTeams",

  model: {
    event: "update",
    prop: "show",
  },

  props: {
    dataProps: {
      type: Object,
      default: () => ({}),
    },
    show: {
      type: Boolean,
      default: false,
    },
    hideQr: {
      type: Boolean,
      default: false,
    },
  },

  components: { WindowPortal, PreviewDocument, PreviewPage },

  data: () => ({
    mailLabel: "",
    pagesData: [[]],
    previewConfig: {
      title: "Vista Previa de Impresión de Factura Electrónica",
      filename: "Factura Electronica.pdf",
      margins: [0, 10, 0, 10],
      unit: "mm",
      format: "letter",
      orientation: "portrait",
    },
    totals: {
      discount: 0,
      exentas: 0,
      noSujetas: 0,
      gravadas: 0,
      otrosMontos: 0,
    },
    maxRowsPerPage: 10,
    imageOpacity: "",
    urlQr: null,
    specialinvoicescolor: JSON.parse(localStorage.getItem("user"))
      .specialinvoicescolor,
    specialInvoicesTitleColor: JSON.parse(localStorage.getItem("user"))
      .specialInvoicesTitleColor,
    kitcoalternativeposclientdata: JSON.parse(localStorage.getItem("user"))
      .kitcoalternativeposclientdata,
    lexlitislatamclientdata: JSON.parse(localStorage.getItem("user"))
      .lexlitislatamclientdata,
    romerolascascadasdata: JSON.parse(localStorage.getItem("user"))
      .romerolascascadasdata,
    keyMaster: JSON.parse(localStorage.getItem("user")).keymaster,
    ShowCorrelativeControl: JSON.parse(localStorage.getItem("user"))
      .showcorrelativecontrol,
    posshowprincipalbarcode: JSON.parse(localStorage.getItem("user"))
      .posshowprincipalbarcode,
  }),
  computed: {
    totalPages() {
      return this.pagesData.length;
    },
    modifiedBranchBilledInfo() {
      const info = this.dataProps.data.branch.BranchBilledInfo;
      if (info) {
        return info.replace(/<p>/g, "").replace(/<\/p>/g, "<br/>");
      }

      return null;
    },
    colorTable() {
      if (this.keyMaster === "3f3355bdc105555f5c6fe11bfd1e5021") {
        if (this.dataProps.data.header.ID_Branch === "109") {
          return { bg: "#A3BD31", fg: "#000000" };
        } else if (this.dataProps.data.header.ID_Branch === "115") {
          return { bg: "#be0811", fg: "white" };
        }
      }

      if (this.specialinvoicescolor) {
        return {
          bg: this.specialinvoicescolor,
          fg: this.specialInvoicesTitleColor || "white",
        };
      } else {
        return { bg: "grey", fg: "black" };
      }
    },
    dateInvoice() {
      const partes = this.dataProps.data.header.InvoiceDate.split("/");
      return {
        dia: partes[0],
        mes: partes[1],
        anio: partes[2],
      };
    },
    commentsOuterHtml() {
      let note = this.dataProps.data.header.InvoiceInternalNote.replace(
        /<[^>]*>/g,
        ""
      );
      let paser = new DOMParser();
      let noteText = paser.parseFromString(note, "text/html").body.textContent;
      return noteText;
    },
  },
  watch: {
    async show(value) {
      if (value) {
        await this.getImages();
        this.getQr();
        this.calculatePages();
      }
    },
  },
  methods: {
    onClose() {
      this.$emit("update", false);
    },
    getCurrentPage(nextRecords = 1) {
      const page = this.pagesData[this.pagesData.length - 1];
      if (page.length + nextRecords <= this.maxRowsPerPage) {
        return page;
      } else {
        this.pagesData.push([]);
        return this.pagesData[this.pagesData.length - 1];
      }
    },
    calculatePages() {
      let index = 1;
      this.pagesData = [[]];
      this.totals = {
        discount: 0,
        exentas: 0,
        noSujetas: 0,
        gravadas: 0,
        otrosMontos: 0,
      };
      for (const item of this.dataProps.data.body) {
        const page = this.getCurrentPage();
        page.push({
          ...item,
          index,
          itemType: 3,
          venAfectas: 0,
          otroMonto: 0,
          montoNoAfecto: 0,
        });
        this.totals.discount += item.ItemDiscount;
        this.totals.exentas += item.ItemExenta;
        this.totals.noSujetas += item.ItemNoSuj;
        this.totals.gravadas += item.ItemGravada;
        index++;
      }
      const page = this.getCurrentPage();
      for (let i = page.length; i < this.maxRowsPerPage - 8; i++) {
        page.push({ index: "&nbsp;" });
      }
    },
    getQr() {
      const partes = this.dataProps.data.header.InvoiceDate.split("/");
      const dia = partes[0];
      const mes = partes[1];
      const anio = partes[2];

      const fechaNueva = `${anio}-${mes}-${dia}`;
      const url =
        this.dataProps.data.branch.AuthFeMode == 1
          ? `https://admin.factura.gob.sv/consultaPublica?ambiente=01&codGen=${this.dataProps.data.header.CodigoGeneracion}&fechaEmi=${fechaNueva}`
          : `https://admin.factura.gob.sv/consultaPublica?ambiente=00&codGen=${this.dataProps.data.header.CodigoGeneracion}&fechaEmi=${fechaNueva}`;

      const opt = {
        errorCorrectionLevel: "H",
        type: "image/png",
        quality: 0.3,
        margin: 1,
        color: {
          dark: "#000000",
          light: "#ffffff",
        },
        width: 100,
      };

      QRCode.toDataURL(url, opt, (error, url) => {
        if (error) {
          console.log("Error al generar el código QR:", error);
          throw error;
        }

        this.urlQr = url;
      });
    },
    formatWithCommas(x) {
      if (isNaN(x)) {
        return "";
      }
      return numberWithCommas(x);
    },
    async getImages() {
      const watermark =
        "https://innova-apps.sfo3.cdn.digitaloceanspaces.com/cocoTeamBackground.png";

      const img = this.dataProps.data.branch.BranchBannerPath;
      const logo = this.dataProps.data.branch.BranchLogoPath;

      if (logo) {
        const LogoBranchBase64 = localStorage.getItem("LogoBranchBase64")

        if (LogoBranchBase64) {
          this.dataProps.data.branch.BranchLogoPath = `${LogoBranchBase64}`;
        }
        else {
          const { imageBase64: logoImageBase64 } = await this.$API.utilities.getImageInBase64({ file: logo });
          this.dataProps.data.branch.BranchLogoPath = `${logoImageBase64}`;
        }
      }

      if (img) {
        const { imageBase64: bannerImageBase64 } =
          await this.$API.utilities.getImageInBase64({ file: img });
        this.dataProps.data.branch.BranchBannerPath = `${bannerImageBase64}`;
      }

      const { imageBase64: opacityBase64 } =
        await this.$API.utilities.getImageInBase64({ file: watermark });
      this.imageOpacity = `${opacityBase64}`;
    },
    assignCuerpoDocumento() {
      this.dataProps.data.header.jsonMH.cuerpoDocumento =
        this.dataProps.data.body.map((item, index) => ({
          descripcion: item.ItemDescription,
          montoDescu: item.ItemDiscount,
          codigo: item.ID_Item,
          ventaGravada: item.ItemGravada,
          ivaItem: item.ItemIva,
          ventaNoSuj: item.ItemNoSuj,
          ventaExenta: item.ItemExenta,
          numItem: index + 1,
          noGravado: item.ItemNoGravada,
          psv: item.ItemPsv,
          uniMedida: item.ItemMeasureUnit,
          cantidad: item.ItemQuantity,
          precioUni: item.ItemUnitPrice,
        }));
    },
    async downLoadJSON() {
      try {
        const selloRecibido =
          JSON.parse(this.dataProps.data.header.ResponseMhJson)
            ?.selloRecibido || "";
        const firmaElectronica =
          this.dataProps.data.header.JsonMhSigned?.documento || "";
        const dteJson =
          this.dataProps.data.header.JsonMh.dteJson ??
          this.dataProps.data.dteJson.JsonMh.dteJson;
        const jsonToSend = { ...dteJson, firmaElectronica, selloRecibido };
        delete jsonToSend.passwordPri;

        const aElement = document.createElement("a");
        aElement.setAttribute(
          "download",
          this.dataProps.data.header.ID_Invoice +
            "_" +
            this.dataProps.data.header.InvoiceDate.replaceAll("/", "-") +
            "_" +
            this.dataProps.data.header.InvoiceName.replaceAll(
              /[:/<>*|/]/g,
              ""
            ).replaceAll('\\"', "") +
            ".pdf"
        );
        this.assignCuerpoDocumento();
        const blob = new Blob([JSON.stringify(jsonToSend)], {
          type: "application/json",
        });
        const href = URL.createObjectURL(blob);
        aElement.href = href;
        aElement.download =
          this.dataProps.data.header.ID_Invoice +
          "_" +
          this.dataProps.data.header.InvoiceDate.replaceAll("/", "-") +
          "_" +
          this.dataProps.data.header.InvoiceName.replaceAll(
            /[:/<>*|/]/g,
            ""
          ).replaceAll('\\"', "") +
          ".json";
        aElement.click();
        URL.revokeObjectURL(href);
      } catch (error) {
        this.mailLabel = "Ocurrió un error al descargar JSON";
        console.log(error);
      }
    },
    async sendEmail(doc) {
      this.mailLabel = "Enviando correo...";
      try {
        const {
          data: {
            header: { jsonMH, InvoiceDate, InvoiceName },
            dteJson: { ID_Invoice },
          },
        } = this.dataProps;

        const body = {
          dtefilebuffer: new Buffer.from(doc.output("arraybuffer")),
          dtejson: { ...jsonMH, ID_Invoice },
          dtefilebufferfilename:
            ID_Invoice +
            "_" +
            InvoiceDate.replaceAll("/", "-") +
            "_" +
            InvoiceName.replaceAll(/[:/<>*|/]/g, "").replaceAll('\\"', ""),
        };

        await this.$API.invoices.sendInvoiceMail(body);

        this.mailLabel = "Se envió el correo correctamente";
        setTimeout(() => {
          this.mailLabel = "";
        }, 8000);
        this.$emit("mailSent");
      } catch (error) {
        this.mailLabel = `Ocurrió el siguiente error al enviar el correo ${error}`;
      }
    },
  },
};
</script>